// Dispatch-er och re-exports för per-block view-komponenter.

import { Block } from '../types';
import { ButtonBlockView } from './ButtonBlockView';
import { DividerBlockView } from './DividerBlockView';
import { HeadingBlockView } from './HeadingBlockView';
import { ImageBlockView } from './ImageBlockView';
import { TextBlockView } from './TextBlockView';
import { TwoColumnsBlockView } from './TwoColumnsBlockView';

export { ButtonBlockView, DividerBlockView, HeadingBlockView, ImageBlockView, TextBlockView, TwoColumnsBlockView };

// Generisk renderare som dispatchar baserat på block.type.
type Props = { block: Block };

export const BlockView = ({ block }: Props) => {
  switch (block.type) {
    case 'heading':
      return <HeadingBlockView block={block} />;
    case 'text':
      return <TextBlockView block={block} />;
    case 'image':
      return <ImageBlockView block={block} />;
    case 'button':
      return <ButtonBlockView block={block} />;
    case 'divider':
      return <DividerBlockView block={block} />;
    case 'twoColumns':
      return <TwoColumnsBlockView block={block} />;
    default: {
      const exhaustive: never = block;
      throw new Error(`Okänd blocktyp i BlockView: ${JSON.stringify(exhaustive)}`);
    }
  }
};
